import React, { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const META = {
  UZS: { flag: '🇺🇿', name: "Uzbek so'm", dp: 0 },
  USD: { flag: '🇺🇸', name: 'US Dollar', dp: 2 },
  EUR: { flag: '🇪🇺', name: 'Euro', dp: 2 },
  GBP: { flag: '🇬🇧', name: 'British Pound', dp: 2 },
  RUB: { flag: '🇷🇺', name: 'Russian Ruble', dp: 2 },
  KZT: { flag: '🇰🇿', name: 'Kazakh Tenge', dp: 2 },
};

export default function CurrencyConverter({ accent = '#0EA5E9' }) {
  const [data, setData] = useState(null);
  const [amount, setAmount] = useState('100');
  const [from, setFrom] = useState('USD');
  const [to, setTo] = useState('UZS');
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    api.get('/api/rates')
      .then(r => { setData(r.data); setErr(''); })
      .catch(() => setErr('Could not load rates'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const rates = data?.rates || {};
  const list = data?.currencies || Object.keys(META);
  const amt = parseFloat(amount) || 0;
  const result = (rates[from] && rates[to]) ? amt * (rates[to] / rates[from]) : null;

  const fmt = (val, ccy) => {
    if (val == null) return '—';
    const dp = META[ccy]?.dp ?? 2;
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: dp, maximumFractionDigits: dp }).format(val);
  };
  const unit = (rates[from] && rates[to]) ? (rates[to] / rates[from]) : null;

  const sel = {
    padding: '10px 12px', borderRadius: 10, border: '1px solid #E2E8F0',
    fontSize: 14, fontWeight: 600, color: '#0F172A', background: '#fff', cursor: 'pointer', flex: 1, minWidth: 0,
  };
  const Option = ({ c }) => <option value={c}>{META[c]?.flag} {c}</option>;

  return (
    <div style={{ background: '#fff', borderRadius: 14, padding: 20, border: '1px solid #E2E8F0' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: '#0F172A' }}>💱 Currency Converter</h3>
        <button onClick={load} disabled={loading}
          style={{ fontSize: 12, color: accent, background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600 }}>
          {loading ? 'Loading…' : '↻ Refresh'}
        </button>
      </div>

      {err ? (
        <div style={{ fontSize: 13, color: '#DC2626' }}>{err}</div>
      ) : (
        <>
          <div style={{ display: 'flex', gap: 10, alignItems: 'flex-end' }}>
            <div style={{ flex: 1.3, minWidth: 0 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#64748B', marginBottom: 5 }}>AMOUNT</label>
              <input type="number" value={amount} onChange={e => setAmount(e.target.value)}
                style={{ ...sel, width: '100%', cursor: 'text' }} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#64748B', marginBottom: 5 }}>FROM</label>
              <select value={from} onChange={e => setFrom(e.target.value)} style={sel}>{list.map(c => <Option key={c} c={c} />)}</select>
            </div>
            <button onClick={() => { setFrom(to); setTo(from); }} title="Swap"
              style={{ padding: '10px 12px', borderRadius: 10, border: '1px solid #E2E8F0', background: '#F8FAFC', cursor: 'pointer', fontSize: 16, marginBottom: 0 }}>⇄</button>
            <div style={{ flex: 1, minWidth: 0 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#64748B', marginBottom: 5 }}>TO</label>
              <select value={to} onChange={e => setTo(e.target.value)} style={sel}>{list.map(c => <Option key={c} c={c} />)}</select>
            </div>
          </div>

          <div style={{ marginTop: 16, padding: 16, borderRadius: 12, background: `${accent}10`, border: `1px solid ${accent}30` }}>
            <div style={{ fontSize: 13, color: '#64748B' }}>{fmt(amt, from)} {from} =</div>
            <div style={{ fontSize: 26, fontWeight: 800, color: '#0F172A', lineHeight: 1.2 }}>
              {fmt(result, to)} <span style={{ fontSize: 16, fontWeight: 700, color: '#64748B' }}>{to}</span>
            </div>
            {unit != null && (
              <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 4 }}>
                1 {from} = {fmt(unit, to)} {to}
              </div>
            )}
          </div>

          <div style={{ fontSize: 11, color: '#94A3B8', marginTop: 10 }}>
            {data?.cbu_date ? `Official rate ${data.cbu_date}` : 'Rate'} · {data?.source || ''}
          </div>
        </>
      )}
    </div>
  );
}
